export default async function updatePersona(repository, preregistro) {
  return repository.updatePersona(preregistro);
}
